import { useTranslation } from "react-i18next";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, TrendingUpIcon, UsersIcon } from 'lucide-react';
export function CustomMetrics() {
  const {
    t
  } = useTranslation("analytics");
  const navigate = useNavigate();
  return <div className="max-w-5xl mx-auto" data-id="element-2356" data-mp="1jndp5w4rueq9">
      {/* Hero Section with Preview Card */}
      <div className="mb-12" data-id="element-2357" data-mp="14yr8nr3ergxg">
        <div className="relative" data-id="element-2358" data-mp="14yhjg5q6tdst">
          {/* Gradient Background Card */}
          <div className="bg-gradient-to-br from-blue-400 via-cyan-400 to-teal-400 rounded-2xl p-8 shadow-xl" data-id="element-2359" data-mp="19p7o1gqshcmg">
            {/* Preview Dashboard Card */}
            <div className="bg-white rounded-xl shadow-lg p-6 max-w-md" data-id="element-2360" data-mp="vzw048cw5uqz">
              <div className="flex items-center justify-between mb-4" data-id="element-2361" data-mp="10y780djmlv6k">
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-2362" data-mp="lzda0vuqhi0m">
                  {t("pages.CustomMetrics.check_daily")}
                </h3>
                <button className="text-sm text-gray-600 hover:text-gray-900" data-id="element-2363" data-mp="qy6oaqhuhd1u">
                  {t("pages.CustomMetrics.see_all")}
                </button>
              </div>
              <p className="text-xs text-gray-500 mb-6" data-id="element-2364" data-mp="2bxmtukce4w9x">{t("pages.CustomMetrics.shared")}</p>

              {/* Metric Cards */}
              <div className="space-y-4" data-id="element-2365" data-mp="2pxo24kuzj5zf">
                {/* Trial conversion rate */}
                <div className="flex items-center justify-between" data-id="element-2366" data-mp="2lxdmeghe517d">
                  <div data-id="element-2367" data-mp="1y6i204f9l8a5">
                    <p className="text-xs text-gray-600 mb-1" data-id="element-2368" data-mp="1y7t1hs1oftvg">
                      {t("pages.CustomMetrics.trial_conversion_rate")}
                    </p>
                    <div className="flex items-baseline gap-2" data-id="element-2369" data-mp="2704spg4m7lch">
                      <span className="text-2xl font-bold text-gray-900" data-id="element-2370" data-mp="271pjqvrq0m5l">
                        56.8%
                      </span>
                      <span className="text-xs text-green-600" data-id="element-2371" data-mp="1eise48ag7s67">+3.1%</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-2372" data-mp="1agnpxp2rrnqy">
                    {/* Mini chart */}
                    <svg width="60" height="30" className="text-blue-500" data-id="element-2373" data-mp="39lff5yol90m5">
                      <polyline points="0,25 10,20 20,22 30,15 40,18 50,10 60,8" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-2374" data-mp="3el1o3vxdvup5" />
                      
                    </svg>
                    <div className="text-right" data-id="element-2375" data-mp="3obd3qfqfjsbv">
                      <p className="text-xs text-gray-600" data-id="element-2376" data-mp="3oa1sxvykhkb9">{t("pages.CustomMetrics.high")}</p>
                      <p className="text-lg font-semibold text-gray-900" data-id="element-2377" data-mp="2qow9xkgwnwuv">598</p>
                      <p className="text-xs text-green-600" data-id="element-2378" data-mp="2vlw5v2k1jj89">+12</p>
                    </div>
                  </div>
                </div>

                {/* New customers */}
                <div className="flex items-center justify-between" data-id="element-2379" data-mp="35kvckfl8x4sm">
                  <div data-id="element-2380" data-mp="35m6gqgilsek9">
                    <p className="text-xs text-gray-600 mb-1" data-id="element-2381" data-mp="fvjo033xakvv">{t("pages.CustomMetrics.new_customers")}</p>
                    <div className="flex items-baseline gap-2" data-id="element-2382" data-mp="kue4uzibxzdc">
                      <span className="text-2xl font-bold text-gray-900" data-id="element-2383" data-mp="kstdtjv84yk8">
                        1,624
                      </span>
                      <span className="text-xs text-green-600" data-id="element-2384" data-mp="20du8bz15mgz5">+4.5%</span>
                    </div>
                  </div>
                  <div className="flex gap-0.5" data-id="element-2385" data-mp="1vm3rrbbmiwza">
                    {/* Mini bar chart */}
                    {[12, 18, 15, 22, 19, 25, 20, 28, 24, 30, 26, 32].map((height, i) => <div key={i} className="w-1.5 bg-purple-500 rounded-sm" style={{
                    height: `${height}px`
                  }} data-id="element-2386" data-mp="1qly569k7o0o2" data-mpi={i} />)}
                  </div>
                </div>
              </div>
            </div>

            {/* Create new group popup */}
            <div className="absolute top-4 right-4 bg-white rounded-lg shadow-xl p-4 w-64" data-id="element-2387" data-mp="1co9mn8dm95m6">
              <h4 className="text-sm font-semibold text-gray-900 mb-3" data-id="element-2388" data-mp="17qrbrcg1ggbj">
                {t("pages.CustomMetrics.create_a_new_group")}
              </h4>
              <div className="mb-3" data-id="element-2389" data-mp="322fvrt14n92s">
                <label className="text-xs text-gray-600 mb-1 block" data-id="element-2390" data-mp="323h77ym21xl1">{t("pages.CustomMetrics.name")}</label>
                <input type="text" value="Growth reports" readOnly className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-gray-50" data-id="element-2391" data-mp="1zqb6p12eksiq" />
                
              </div>
              <button className="w-full flex items-center justify-center gap-2 px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-2392" data-mp="1pqke54xeknla">
                <PlusIcon size={16} data-id="element-2393" data-mp="1g10qllyqw5k3" />
                {t("pages.CustomMetrics.add_reports")}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="text-center mb-8" data-id="element-2394" data-mp="171dy5pnzua36">
        <h1 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-2395" data-mp="172p49w4wvtxg">
          {t("pages.CustomMetrics.monitor_your_data_with_custom_metrics")}
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-2396" data-mp="x26dehexjd61">
          {t("pages.CustomMetrics.create_custom_metrics_with_nadi_to")}
        </p>
      </div>

      {/* CTA Button */}
      <div className="text-center" data-id="element-2397" data-mp="ifzgdtxxoag0">
        <button onClick={() => navigate('/nadi')} className="inline-flex items-center px-6 py-3 text-base font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-sm transition-colors" data-id="element-2398" data-mp="ih0uk7a8xd1y">
          
          {t("pages.CustomMetrics.go_to_nadi")}
        </button>
      </div>

      {/* Feature Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-16" data-id="element-2399" data-mp="ndhkn710a1ho">
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2400" data-mp="11e213wjg7l80">
          <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4" data-id="element-2401" data-mp="xd8i9hkv4wlz">
            <TrendingUpIcon size={24} className="text-blue-600" data-id="element-2402" data-mp="1b4dj2mzyvuxw" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-2403" data-mp="1b6hlf0i7wlw2">
            {t("pages.CustomMetrics.track_key_metrics")}
          </h3>
          <p className="text-sm text-gray-600" data-id="element-2404" data-mp="1l21frih4vcip">
            {t("pages.CustomMetrics.monitor_your_most_important_business_metrics")}
          </p>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2405" data-mp="1g1wxpo0ku9qd">
          <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4" data-id="element-2406" data-mp="1n8itnb5rhqy1">
            <UsersIcon size={24} className="text-purple-600" data-id="element-2407" data-mp="1s6anwbtvpp5e" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-2408" data-mp="1x4c50r7qvee8">
            {t("pages.CustomMetrics.share_insights")}
          </h3>
          <p className="text-sm text-gray-600" data-id="element-2409" data-mp="21xx3ekd92ady">
            {t("pages.CustomMetrics.collaborate_with_your_team_by_sharing")}
          </p>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-2410" data-mp="2avha48tvsyvy">
          <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4" data-id="element-2411" data-mp="2fvvad4p8r4jf">
            <PlusIcon size={24} className="text-green-600" data-id="element-2412" data-mp="2kv85ecq9nhx3" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-2413" data-mp="2ksc6om6lgp7l">
            {t("pages.CustomMetrics.easy_to_create")}
          </h3>
          <p className="text-sm text-gray-600" data-id="element-2414" data-mp="qfvtt2jamctr">
            {t("pages.CustomMetrics.build_custom_metrics_with_an_intuitive")}
          </p>
        </div>
      </div>
    </div>;
}